<template>
  <div class="row">
    <div class="col-12">
      <page-header :page="page" />
    </div>
    <div class="col-12 flip-cards-container">
      <squareOption
        v-for="(option, index) in optionList"
        :key="index"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import { name as userModuleName } from '@/modules/user/store';
import squareOption from '@/components/common/menu/SquareOption';
import navMenuTitles from '@/utils/constants/navMenuTitles';
import PageHeader from 'PageHeader';

import { mapState } from 'vuex';

export default {
  components: {
    squareOption,
    PageHeader,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-cog',
        title: 'Usuario',
        routes: ['Inicio', 'Usuario'],
      },
    };
  },
  computed: {
    ...mapState(userModuleName, ['userMenu']),
    optionList() {
      return (
        this.userMenu
          .find((x) => x.title === navMenuTitles.User)
          ?.children.map((item) => ({
            title: item.title,
            description: item.description,
            detail: item.detail,
            icon: item.iconClasses,
            mainImage: item.mainImagePath,
            hoverImage: item.mainImageHoverPath,
            needSelectedStudent: item.needSelectedStudent,
            route: item.navigationPath,
          })) || []
      );
    },
  },
};
</script>
